import { Card, Col, Row, Select, Typography } from "antd";
import React from "react";
import Box from "../../../../components/Box/Box";
import AttendanceStats from "./AttendanceStats";
import EmployeePresent from "./AttendancePast/EmployeePresent";
import { CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons';
import WorkStatsChart from "./AttendancePast/WorkStatsChart";
import EmployeeMetricsChart from "./AttendancePast/EmployeeMetricsChart";
import DateRangeDropdown from "../../../../components/Dashboard/DateRangeDropdown";

const { Option } = Select;
const { Title, Text } = Typography;

const AttendanceSummary = () => {
    const departments = ['All Departments', 'HR', 'Engineering', 'Marketing', 'Sales'];
    const [selectedDept, setSelectedDept] = React.useState('All Departments');
    const [selectedDate, setSelectedDate] = React.useState('');
    const [selectedType, setSelectedType] = React.useState('employee_present');

    // Mock Data for Stats
    const stats = [
        { key: 'employee_present', title: 'Employees Present', value: '89.88%', description: 'Percentage of employees present', icon: <CalendarOutlined />, color: '#1890ff' },
        { key: 'avg_work_hour', title: 'Avg. Work Hours Spent', value: '8h 9m/day', description: 'Average effective hours worked', icon: <ClockCircleOutlined />, color: '#52c41a' },
        { key: 'avg_overtime_hour', title: 'Avg. Overtime Hours', value: '1h 48m/day', description: 'Average overtime per employee', icon: <ClockCircleOutlined />, color: '#faad14' },
    ];

    return <Row gutter={[16, 16]}>
        <Col span={24}>
            <Box title="Attendance Summary" actions={<Select defaultValue="All Departments" style={{ width: 150 }} >
                {departments.map((dept) => (
                    <Option key={dept} value={dept}>
                        {dept}
                    </Option>
                ))}
            </Select>}>
                <AttendanceStats />
            </Box>
        </Col>
        <Col span={24}>
            <Box title="Attendance for past dates" actions={<DateRangeDropdown />}>
                <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                    {stats.map((stat, index) => (
                        <Col xs={24} md={8} key={index}>
                            <Card onClick={() => setSelectedType(stat.key)} style={{ background: selectedType == stat.key ? 'lightGray' : '', cursor: 'pointer' }}>
                                <Row align="middle" gutter={16}>
                                    <Col>
                                        <div style={{ fontSize: '32px', color: stat.color }}>{stat.icon}</div>
                                    </Col>
                                    <Col>
                                        <Title level={3}>{stat.value}</Title>
                                        <Text strong>{stat.title}</Text>
                                        <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{stat.description}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    ))}
                </Row>
                {selectedType == 'employee_present' && <EmployeePresent />}
                {selectedType == 'avg_work_hour' && <WorkStatsChart />}
                {selectedType == 'avg_overtime_hour' && <EmployeeMetricsChart />}
            </Box>
        </Col>

    </Row>
}

export default AttendanceSummary;